import React from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    ScrollView,
    StyleSheet,
    ActivityIndicator,
    Alert,
    ToastAndroid
} from 'react-native';

import { Formik, FormikProps } from 'formik';
import { AuthContext } from '../contexts/auth/Store';
import * as Yup from 'yup';
import { AnalyticsService } from "../constants/Analytics";

import FeedbackModal from '../components/modals/FeedbackModal';
import FormikInput from '../components/form/FormikInput';
import FontStyles from '../constants/FontStyle';
import Colors from '../constants/Colors';
import FormikSelectList from '../components/form/FormikSelectList';
import StyledButton from '../components/StyledButton';
import http from '../utils/http';
import GenericHeader from '../components/headers/GenericHeader';

const analytics = new AnalyticsService

const FeedbackSchema = Yup.object().shape({
    type: Yup.string()
        .required('Select type'),
    body: Yup.string()
        .required('Feedback is required'),
});

function FeedbackScreen({ navigation }) {

    const auth = React.useContext(AuthContext)
    const [modalState, setModalState] = React.useState(false)

    const hideModal = () => {
        setModalState(false)
    }
    
    const token = null
    const user_id = null
    const buyer = null

    const list = [
        {
            _id: 'general',
            name: 'General'
        },
        {
            _id: 'order',
            name: 'Order'
        },
        {
            _id: 'pricing',
            name: 'Pricing'
        },
        {
            _id: 'other',
            name: 'Other'
        }
    ]

    try {
        token = auth.getUserData.userToken
        user_id = auth.getUserData.buyerData.user_id
        buyer = auth.getUserData.buyerData
    } catch(e) {
    }

    const submit = (values, setSubmitting, resetForm) => {

        let form = new FormData()
        form.append('flag', values.type)
        form.append('body', values.body)
        form.append('sender', user_id)
        form.append('recipient', '*')
        form.append('status', 'active')

        http.post('ticket/create', form, token)
            .then(res => {
                setSubmitting(false)
                if (res.code === 200) {
                    analytics.logEvent('Submitted Feedback', buyer, {
                        flag: values.type,
                        review: values.body,
                    })
                    setModalState(true)
                    resetForm({
                        type: 'general',
                        body: '',
                    })
                } else {
                    // ToastAndroid.show(res.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                }
            })
            .catch(err => {
                setSubmitting(false)
                console.log(err)
                // ToastAndroid.show('Error. Please try again.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
            })
    }


    return (
        <View style={{ flex: 1 }}>
            <GenericHeader
                title="Submit Feedback"
            />
            <ScrollView contentContainerStyle={styles.scrollview}>
                <Formik
                    initialValues={
                        {
                            type: 'general',
                            body: '',
                        }
                    }
                    validationSchema={FeedbackSchema}
                    onSubmit={
                        (values, actions) => {
                            // actions.setSubmitting(false)
                            // actions.resetForm()
                            submit(values, actions.setSubmitting, actions.resetForm)
                        }
                    }
                >
                    {({ handleBlur, handleChange, handleSubmit, values, errors, touched, isSubmitting, setFieldValue, isValid }) => (
                        <View style={styles.container}>
                            {/* form goes here */}

                            <FormikSelectList
                                fieldName="type"
                                label="Feedback Type"
                                placeholder="Choose feedback type"
                                options={list}
                            />

                            <FormikInput
                                fieldName="body"
                                label="Feedback"
                                placeholder="Tell us more"
                                multiline={true}
                                numberOfLines={7}
                            />

                            <StyledButton
                                label="Send Feedback"
                                disabled={(isSubmitting || !isValid)}
                                isSubmitting={isSubmitting}
                                action={handleSubmit}
                                style={{
                                    marginTop: 32,
                                    marginBottom: 63
                                }}
                            />
                        </View>
                    )}
                </Formik>

            </ScrollView>
            <FeedbackModal modalState={modalState} hideModal={hideModal} />
        </View>
    )
}

export default FeedbackScreen

const styles = StyleSheet.create({
    container: {
        flex: 1,
        // alignItems: 'flex-start',
        // justifyContent: 'flex-start',
        paddingHorizontal: 16
    },
    scrollview: {
        flex: 1,
        backgroundColor: Colors.whiteColor,
    }
})